import { EN_Phrases } from '../../../../translations';

const FIELD_TRANSLATION_PREFIXES: Record<string, string[]> = {
  eventSource: ['events.content.eventSource.'],
  eventFlowStatus: ['eventflow.category.'],
  pensionScheme: ['products.type.'],
  syncStatus: ['connection.processes.result.'],
};

const BOOLEAN_TRANSLATION_CANDIDATES: Record<'true' | 'false', string[]> = {
  true: ['true', 'yes'],
  false: ['false', 'no'],
};

const getTranslationIdIfExists = (id: string) => (Object.hasOwn(EN_Phrases, id) ? id : null);

export const getPensioenbijAutoValueTranslationId = (field: string, value: unknown) => {
  if (typeof value === 'boolean') {
    const candidates = BOOLEAN_TRANSLATION_CANDIDATES[value ? 'true' : 'false'];

    for (const candidate of candidates) {
      const translationId = getTranslationIdIfExists(candidate);
      if (translationId) return translationId;
    }

    return null;
  }

  if (typeof value !== 'string') return null;

  const prefixes = FIELD_TRANSLATION_PREFIXES[field];
  if (!prefixes?.length) return null;

  for (const prefix of prefixes) {
    const translationId = getTranslationIdIfExists(`${prefix}${value}`);
    if (translationId) return translationId;
  }

  return null;
};
